import { createAsyncThunk } from '@reduxjs/toolkit';
import { companySerive } from '../../services';

const getAllCompanies = createAsyncThunk(
    'companies/getAllCompanies',
    async (payload, thunkAPI) => {
        try {
            const response = await companySerive.getAllCompanies();
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getCompanyByHash = createAsyncThunk(
    'companies/getCompanyByHash',
    async (payload, thunkAPI) => {
        try {
            const local_user_company = localStorage.getItem('user_company');
            const companyHash = payload.companyHash !== null && payload.companyHash !== '' ? payload.companyHash : local_user_company != undefined ? local_user_company : ''; 

            const response = await companySerive.getCompanyByHash(companyHash);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getUserCompany = createAsyncThunk(
    'companies/getUserCompany',
    async (payload, thunkAPI) => {
        try {
            const response = await companySerive.getUserCompany();
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getCustomerSettings = createAsyncThunk(
    'companies/getCustomerSettings',
    async (payload, thunkAPI) => {
        try {
            const response = await companySerive.getCustomerSettings(payload.companyId);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getEditCustomerSettings = createAsyncThunk(
    'companies/getEditCustomerSettings',
    async (payload, thunkAPI) => {
        try {
            const response = await companySerive.getEditCustomerSettings(payload.customerId);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getChannelAndVendor = createAsyncThunk(
    'companies/getChannelAndVendor',
    async (payload, thunkAPI) => {
        try {
            const response = await companySerive.getChannelAndVendor();
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const editCustomerDetails = createAsyncThunk(
    'companies/editCustomerDetails',
    async (payload, thunkAPI) => {
        try {
            const response = await companySerive.editCustomerDetails(payload.data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteCustomerSettings = createAsyncThunk(
    'companies/deleteCustomerSettings',
    async (payload, thunkAPI) => {
        try {
            const response = await companySerive.deleteCustomerSettings(payload.customerId);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getCompanyConfigurationByTag = createAsyncThunk(
    'companies/getCompanyConfigurationByTag',
    async (payload, thunkAPI) => {
        try {
            const response = await companySerive.getCompanyConfigurationByTag(payload.companyId);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const postCompanyConfigurationAuto = createAsyncThunk(
    'companies/postCompanyConfigurationAuto',
    async (payload, thunkAPI) => {
        try {
            const response = await companySerive.postCompanyConfigurationAuto(payload.companyId, payload.data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export {
    getAllCompanies,
    getCompanyByHash,
    getUserCompany, 
    getCustomerSettings, 
    getEditCustomerSettings, 
    getChannelAndVendor, 
    editCustomerDetails, 
    deleteCustomerSettings,
    getCompanyConfigurationByTag,
    postCompanyConfigurationAuto 
};
